import React, {Fragment, useEffect, useState, useRef} from "react";
import { Link } from "react-router-dom";
import {cluster, getClientOnRampSecret, getClientStripeSecret, getClientStripeSecretReload1, getPrivateKeyBase58, getUserSessionData, stripe_pub_key} from "./constants";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { ToastContainer, toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';

import {Elements, PaymentElement, useElements, useStripe} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import CheckoutForm from "./CheckoutForm";
import CheckoutFormOld from "./CheckoutFormOld";

const TestStripePayment = (props : any) => {


    const [secret, setSecret] = useState<string>('');
    const [showStripe, setShowStripe] = useState(false);
    const handleCloseStripe = () => setShowStripe(false);
    const handleShowStripe = () => setShowStripe(true);

    const [showError, setShowError] = useState(false);
    const handleCloseError = () => setShowError(false);
    const handleShowError = () => setShowError(true);
    
    const [mintError, setMintError] = useState("");
    const [mintErrorHeader, setMintErrorHeader] = useState("");

    const stripePromise = loadStripe(stripe_pub_key);
  
    const options = {
        clientSecret: secret,
    };

    const openStripe = async () => {

        const resp = await getClientStripeSecretReload1(100);
        setSecret(resp.clientSecret);
        // console.log(clientSecret);
        handleShowStripe();
    }

    const showSuccessPayment = () => {
        handleCloseStripe();
        setMintErrorHeader('Notification');
        setMintError('Payment Successful');
        handleShowError();
    }

    return (
        <Fragment>
             <button className="buttonLink btn-logout" onClick={openStripe}>Do Payment</button>

             
             <Modal className="modal-error" show={showError} onHide={handleCloseError} backdrop="static">
                <Modal.Header closeButton={true}>
                <Modal.Title>{mintErrorHeader}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
    
                    <div>
                        {mintError}
                    </div>
    
                </Modal.Body>
                <Modal.Footer>
                </Modal.Footer>
            </Modal> 
            
                <Modal className="modal-payment" size="sm" show={showStripe} onHide={handleCloseStripe} backdrop="static">
                <Modal.Header closeButton={true}>
                {/* <Modal.Title>Notification</Modal.Title> */}
                </Modal.Header>
                    <Modal.Body>
                    <div style={{ "textAlign" : "center"}}>
                        {
                            secret &&   
                            <Elements options={options} stripe={stripePromise}>
                                <CheckoutFormOld amount="100" secret={secret} showSuccessPayment={showSuccessPayment} mint={showSuccessPayment} />
                            </Elements>
                        }
                    </div>
        
                    </Modal.Body>
                    <Modal.Footer>
                    </Modal.Footer>
                </Modal> 

        </Fragment>

    );
}

export default TestStripePayment;